import Link from "next/link";

import ImageWithFallback from "./ImageWithFallback";
import { format, formatDistance } from "date-fns";
import Refresh from "./Icons/Refresh";
import Image from "next/image";
const HeaderButton = (props) => {
  return (
    <Link href={props.link}>
      <span className="cursor-pointer text-white bg-[#016937] rounded-[8px] h-[50px] justify-center items-center flex px-[45px] text-[12px] uppercase font-bold">
        {props.text}
      </span>
    </Link>
  );
};

const HeaderButtonWidget = ({ globalPoolId, entry, tournamentStatus }) => {
  return (
    <div className="flex justify-end gap-x-[8px] sm:flex-row flex-col gap-y-[8px] items-end">
      {tournamentStatus !== "CLOSED" && (
        <HeaderButton text="View Global Pool" link={`/pool/${globalPoolId}`} />
      )}
      {tournamentStatus === "OPEN" && (
        <HeaderButton
          text={entry.length > 0 ? "Change Entry" : "Make Entry"}
          link={`/make_entry?poolId=${globalPoolId}`}
        />
      )}
    </div>
  );
};

const lastUpdated = (updatedDate) => {
  const dateSentence = formatDistance(new Date(updatedDate), new Date(), {
    addSuffix: true,
  });
  return (
    <>
      <Refresh width={4} height={4} />
      &nbsp;{dateSentence}
    </>
  );
};

const CurrentTournamentHeader = (props) => {
  const tournamentName =
    props.status === "CLOSED" ? "No tournaments open" : props.name;
  return (
    <div className="flex relative rounded-[8px] col-span-1 md:col-span-2 overflow-hidden">
      <div className="absolute w-full h-full z-0">
        <ImageWithFallback
          src={
            props.picture ||
            "https://stgolfchampsprodeastus.blob.core.windows.net/public/Default.jpg"
          }
          fallBackSrc="https://stgolfchampsprodeastus.blob.core.windows.net/public/Default.jpg"
          layout="fill"
          alt="Cover tournament image"
        />
      </div>
      <div className="flex w-full bottom-0 top-0 text-white p-[25px] font-['Montserrat'] z-0">
        <div className="w-full flex flex-col gap-y-[8px]">
          <div className="bg-white text-black font-bold text-[14px] uppercase p-[10px] justify-between items-center flex">
            <span>{tournamentName}</span>
            {props.date !== null && (
              <span className="font-normal text-[12px]">
                {props.date && format(new Date(props.date), "EEEE d MMMM yyyy")}
              </span>
            )}
          </div>
          {props.lastUpdated !== null && props.status === "LOCKED" && (
            <span className="flex items-center text-[14px] sm:text-md drop-shadow-md uppercase">
              {lastUpdated(props.lastUpdated)}
            </span>
          )}
          <HeaderButtonWidget
            globalPoolId={props.globalPoolId}
            entry={props.entry}
            tournamentStatus={props.status}
          />
        </div>
      </div>
    </div>
  );
};

export default CurrentTournamentHeader;
